import { BreakpointDefinition } from "utils/Breakpoint";
import { createSelector } from "reselect";

import getShowVerticallySplitControls from "./getShowVerticallySplitControls";
import getBreakpoint from "./getBreakpoint";

export default createSelector(
  [getBreakpoint, getShowVerticallySplitControls],
  (breakpoint, showVerticallySplitControls) =>
    breakpoint.isLessThanOrEquals(BreakpointDefinition.SM_PLUS) ||
    showVerticallySplitControls,
);
